<template>
  <div class="header">
    <h1>用戶新增/修改</h1>
  </div>
  <div
    v-for="item in userInfo"
    :key="item"
    class="col-12 d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-2 text-center">{{ item.label }}</span>
    <div class="col-11 d-flex align-items-center position-relative">
      <input
        class="rounded-pill border info"
        v-model="item.value"
        :type="item.type"
        :placeholder="item.placeholder"
        :disabled="item.name === 'username' && $route.query.id"
      />
      <img
        v-if="item.name === 'new_password' || item.name === 'new_password2'"
        class="show-password"
        :src="
          item.type === 'text'
            ? require('@/assets/icons/open-eye.svg')
            : require('@/assets/icons/close-eye.svg')
        "
        :alt="item.type === 'text' ? 'open-eye' : 'close-eye'"
        @click="item.type = item.type === 'password' ? 'text' : 'password'"
      />
    </div>
  </div>

  <div
    class="position-relative d-flex align-items-center justify-content-between pt-4 pb-4 col-12"
  >
    <span class="text-nowrap col-2 text-center">啟用</span>
    <div class="d-flex align-items-center" style="width: 100%; flex-wrap: wrap">
      <div
        v-for="option in options"
        :key="option"
        class="options"
        :class="state === option.value ? 'active' : ''"
      >
        <div
          class="radio"
          :class="state === option.value ? 'radio-active' : ''"
          @click="state = option.value"
        >
          <div />
        </div>
        {{ option.text }}
      </div>
    </div>
  </div>
  <div class="position-relative d-flex align-items-start pb-5 col-12">
    <span class="text-nowrap col-2 text-center mt-1">管理者群組</span>
    <div class="d-flex align-items-center" style="width: 100%; flex-wrap: wrap">
      <div
        v-for="option in groupList"
        :key="option"
        class="options"
        :class="!isSuper && isGroup.findIndex((e) => e === option.id) >= 0 ? 'active' : ''"
      >
        <div
          class="radio"
          :class="
            !isSuper && isGroup.findIndex((e) => e === option.id) >= 0 ? 'radio-active' : ''
          "
          @click="addGroup(option.id)"
        >
          <div />
        </div>
        {{ option.name }}
      </div>
      <div
        :class="{ 'active' : isSuper && !isGroup.length}"
        class="options"
      >
        <div
          class="radio"
          :class="{ 'radio-active' : isSuper && !isGroup.length}"
          @click="((isSuper = true),isGroup = [])"
        >
          <div />
        </div>
        超級管理員
      </div>
    </div>
  </div>
  <div class="col-12 d-flex align-items-center justify-content-center">
    <button
      @click="submit"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      完成
    </button>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import MsgBox from '@/components/MsgBox.vue'
import usePermission from '@/composables/usePermission'
import { computed } from '@vue/runtime-core'
import router from '@/router'
import { useRoute } from 'vue-router'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'

export default {
  components: {
    MsgBox,
  },
  setup() {
    const { get_manager_list, get_group_list, edit_manager, create_manager } =
      usePermission()
    const route = useRoute()
    const options = ref([
      { text: '啟用', value: '1' },
      { text: '凍結', value: '2' },
    ])
    const showMsgBox = ref(false)
    const showPassword = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const name = ref('')
    const state = ref('1')
    const formList = ref([])
    const showPhoto = ref(false)
    const image = ref('')
    const groupList = ref([])
    const isGroup = ref([])
    const userId = ref(null)
    const isSuper = ref(null)
    const getList = async () => {
      if (route.query.id) {
        const manager = await get_manager_list()
        const item = manager.ret.data.find((e) => +e.id === +route.query.id)
        userId.value = route.query.id
        userInfo.value[0].value = item.realname
        userInfo.value[1].value = item.username
        userInfo.value[4].value = item.remark
        console.log('item',item);
        state.value = item.state
        isSuper.value = +item.is_super 
        if (item.role_info.length) {
          for (const i in item.role_info) {
            isGroup.value.push(item.role_info[i])
          }
        }
      }
      const res = await get_group_list()
      groupList.value = res.ret.data
    }
    getList()
    const userInfo = ref([
      {
        name: 'realname',
        label: '姓名',
        placeholder: '請輸入姓名 ',
        type: 'text',
        value: undefined,
      },
      {
        name: 'username',
        label: '帳號',
        placeholder: '請輸入帳號 ',
        type: 'text',
        value: undefined,
      },
      {
        name: 'new_password',
        label: '密碼',
        placeholder: '請輸入密碼 ',
        type: 'password',
        value: undefined,
      },
      {
        name: 'new_password2',
        label: '確認密碼',
        placeholder: '請輸入確認密碼 ',
        type: 'password',
        value: undefined,
      },
      {
        name: 'remark',
        label: '備註',
        placeholder: '請輸入備註 ',
        type: 'text',
        value: undefined,
      },
    ])
    const addGroup = (id) => {
        isSuper.value = false
        isGroup.value = [id]
      // if (isGroup.value.findIndex((e) => e === id) < 0) {
      //   isGroup.value.push(id)
      // } else {
      //   const remove = isGroup.value.findIndex((e) => e === id)
      //   isGroup.value.splice(remove, 1)
      // }
    }
    const formData = computed(() => {
      const info = userInfo.value.reduce(function (target, key) {
        target[key.name] = key.value
        return target
      }, {})
      info.state = state.value
      info.auth_ids = isSuper.value ? '0' : isGroup.value
      info.id = userId.value
      info.password = info.new_password
      info.password2 = info.new_password2
      return info
    })

    const submit = async () => {
      if (userId.value !== null) {
        const res = await edit_manager(formData.value)
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          showMsgBox.value = true
          errorMsg.value = '編輯成功'
          setTimeout(() => {
            router.push('/user-management/user-manager-list')
          }, 1000)
        }
      } else {
        const res = await create_manager(formData.value)
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          showMsgBox.value = true
          errorMsg.value = '新增成功'
          setTimeout(() => {
            router.push('/user-management/user-manager-list')
          }, 1000)
        }
      }
      manualToggleLoading(false)
    }
    return {
      userInfo,
      errorCode,
      options,
      submit,
      showMsgBox,
      errorMsg,
      name,
      state,
      getList,
      formList,
      showPhoto,
      image,
      showPassword,
      formData,
      groupList,
      isGroup,
      addGroup,
      isSuper
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
.state {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
input::placeholder {
  font-size: 16px;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}

.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
.show-password {
  right: 32px;
  position: absolute;
  cursor: pointer;
}
.options {
  display: flex;
  align-items: center;
  width: 120px;
  color: #4d4d4d;
  font-size: 14px;
  margin: 5px 0;
}
.radio {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 999px;
  border: 1px solid #cccccc;
  padding: 4px;
  cursor: pointer;
}
.active {
  color: #177baf;
}
.radio-active {
  border: 1px solid #177baf;
  div {
    width: 100%;
    height: 100%;
    border-radius: 999px;
    background: #177baf;
  }
}
</style>
